import React, { useState } from 'react';
import { getToken } from 'firebase/messaging';
import { messaging } from '../api/firebase';

export default function Subscribe() {
    console.log("zxfghj", messaging);
    const[key, setKey] = useState()
    const enableNotifications = async () => {
        try {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
                alert('Permission denied');
                return;
            }

            const token = await getToken(messaging, {
                vapidKey: undefined
            });
            console.log('FCM TOKEN:', token);
            setKey(token);

            alert('FCM Token generated. Check console.');
        } catch (err) {
            console.error(err);
            alert('Error generating token');
        }
    };


    return (

        <div style={{ padding: '40px' }}>
            <h2>Firebase Cloud Messaging</h2>
            <button onClick={enableNotifications}>
                Enable Notifications
            </button>
            <p >{key}</p>
        </div>

    );
}
